<div class="component-container">
  <p-button
    label="{{ label | translate }}"
    [size]="size"
    [outlined]="outlined"
    [severity]="status"
    [link]="isLink"
    [raised]="raised"
    [rounded]="rounded"
    [icon]="icon"
    [iconPos]="iconPosition"
    [loading]="loading"
    [disabled]="disabled"
    (onClick)="buttonClicked.emit(true)"
  />
</div>
